<div>
    <app-filter-view [dropdownListBO]="dropdownListBO" [dropdownListOrderCluster]="dropdownListOrderCluster"
        [dropdownListCustomer]="dropdownListCustomer" [dropdownListCountry]="dropdownListCountry"
        [dropdownListMonth]="dropdownListMonth" [dropdownListYear]="dropdownListYear"
        [dropdownListOrderType]="dropdownListOrderType" [orderTypeOfOrderCLuster]="orderTypeOfOrderCLuster"
        [customerOfCountry]="customerOfCountry" [selectedItemsBO]="selectedItemsBO"
        [selectedItemsOrderCluster]="selectedItemsOrderCluster" [selectedItemsCustomer]="selectedItemsCustomer"
        [selectedItemsCountry]="selectedItemsCountry" [selectedItemsMonth]="selectedItemsMonth"
        [selectedItemsYear]="selectedItemsYear" [selectedItemsOrderType]="selectedItemsOrderType"
        [idLeadGlobalOfCustomerName]="idLeadGlobalOfCustomerName" [selectedItemsIdGlobal]="selectedItemsIdGlobal"
        [dropdownListOrderStatus]="dropdownListOrderStatus" [dropdownListLead]="dropdownListLead"
        [selectedItemsOrderStatus]="selectedItemsOrderStatus" [selectedItemsLead]="selectedItemsLead"
        [viewMonth]="viewMonth" [viewOrderStatus]="viewOrderStatus" [overviewOrderdDetailReportSpan]="true"
        [slaKpiSpan]="false" [completedDetailSpan]="false" (sendFilterEvent)="loadReport($event)"
        (updateFilterEvent)="updateFilterEvent($event)">
    </app-filter-view>
</div>

<div class="d-flex justify-content-start mt-4" *ngIf="viexExportPdf()">

    <button class="btn btn-primary btn-lg active btn-sm reset-style" (click)="initializeTendine()">RESET ALL FILTERS</button>

    <button class="btn btn-primary btn-lg active btn-sm logout-style ml-4" (click)="htmltoPDF()">EXPORT PDF</button>
</div>

<div #reportOverview style="margin-top:4%;">
    <div class="d-flex align-items-center mt-4">





        <div class="chartClass">


            <canvas baseChart [data]="pieChartData" [labels]="pieChartLabels" [chartType]="pieChartType"
                [options]="pieChartOptions" [plugins]="pieChartPlugins" [legend]="pieChartLegend" [colors]="colors">
            </canvas>


        </div>

        <div class="card card-dimension" *ngIf="viewCards()">
            <div  class="card-body card-body-style">
                <p style="color:#9C9C9C" class="card-text font-style-size-number">{{getSumOrders()}}</p>
                <p style="color:#2b2b2b;" class="card-text font-style-size">Total Orders</p>
            </div>
        </div>




    </div>
    <div class="d-flex flex-row separator-div" *ngIf="viewCards()">

    </div>
    <div class="d-flex flex-row background-separator-div p-2" *ngIf="viewCards()">
        <div class="card-dimension" >
            <div style="padding:4%;"  class="card-body card-body-style background-white">
                <p style="color:#66FF66;" class="card-text font-style-size-number">{{getSumCompleted()}}</p>
                <p style="color:#2b2b2b;" class="card-text font-style-size">Completed</p>

            </div>
        </div>
        <div style="margin-left:1%;" class="card-dimension" >
            <div style="padding:4%;" class="card-body card-body-style background-white">

                <p style="color:#5271ff;" class="card-text font-style-size-number">{{getSumProgress()}}</p>
                <p style="color:#2b2b2b;" class="card-text font-style-size">In progress</p>

            </div>
        </div>
        <div style="margin-left:1%;" class="card-dimension"  >
            <div style="padding:4%;"  class="card-body card-body-style background-white">

                <p style="color:#FE0000;" class="card-text font-style-size-number">{{getSumFailed()}}</p>
                <p style="color:#2b2b2b;" class="card-text font-style-size">Failed</p>

            </div>
        </div>
    </div>
    <div class="d-flex flex-row separator-div" *ngIf="viewCards()">

    </div>
</div>